import clsx from "clsx";
import { func, number, string } from "prop-types";
import { memo, useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectCurrentPage } from "slices/documentViewer/selectors";
import { getRegexByTerm } from "utils/terms/regex";

import Ellipsis from "../../Ellipsis";
import { PAGE_INTRO_LIMIT } from "../constants";
import DocumentViewerContext from "../DocumentViewerContext";
import classes from "./PageNavigationButton.module.scss";

const PageNavigationButton = ({ onClickPage, textContent = "", page }) => {
  const { termsToHighlight } = useContext(DocumentViewerContext);
  const currentPage = useSelector(selectCurrentPage);
  const intro = textContent.substring(0, PAGE_INTRO_LIMIT);
  const activePage = currentPage === page;

  const isVisible = useMemo(() => {
    if (!termsToHighlight.length) {
      return true;
    }

    return termsToHighlight.some((data) => {
      const regex = getRegexByTerm(data);

      return regex.test(textContent);
    });
  }, [termsToHighlight.length, textContent]);

  if (!isVisible) {
    return null;
  }

  const className = clsx(classes["vt_page_navigation_button"], {
    [classes["vt_page_navigation_button--active"]]: activePage,
  });

  return (
    <li className={className} data-testid={`page-navigation-p${page}`}>
      <button onClick={() => onClickPage(page)}>
        <span className={classes["vt_page_navigation_button__page"]}>
          Pg. {page}:
        </span>

        <Ellipsis enableTooltip={false} text={intro} />
      </button>
    </li>
  );
};

PageNavigationButton.propTypes = {
  onClickPage: func,
  textContent: string,
  page: number,
};

export default memo(PageNavigationButton);
